import React, { useState, useEffect } from 'react'
import DropDownList from '../../components/DropDownList'
import styles from './MapOptions.module.scss'
import Spinner from '../../components/Loader/Spinner'
import { useGeoFetch, useGeoState } from '../../components/GeoProvider'
import Modal from '../../components/ModalCopilot'
import birIcon from '../../assets/images/icon/open-ai.png'
import remarkGfm from 'remark-gfm'
import ReactMarkdown from 'react-markdown'
const normalizeMarkdown = (content) => {
  const raw =
    content.Content !== undefined
      ? content.Content[0].Text.toString()
      : content.toString()
  // Replace literal \\n escape sequences with real newlines
  return raw.replace(/\\n/g, '\n')
}

const AIContent = ({ content }) => {
  if (!content || content === '') return null
  return (
    <div className={styles.AIContent}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>
        {normalizeMarkdown(content)}
      </ReactMarkdown>
    </div>
  )
}
const Filters = () => {
  let promptText = 'You are an analytics assistant. Based on the given filtered dataset, generate a concise, business-friendly summary highlighting only the most important and actionable insights. Focus on the following: 1. Top Performers - Identify which state, age group, gender, and vaccine type have the highest eligibility rate. - Highlight the best-performing combined segment if meaningful (e.g., gender + age group or state + age group). 2. Key Comparisons - Identify any significant differences between genders across age groups (e.g., where one gender has higher eligibility than the other). - Highlight the largest gap observed across any dimension (state, age group, gender, or vaccine). 3. Underperformance / Risk Areas - Identify the lowest-performing state or segment in terms of eligibility. - Highlight any segments where eligibility is low but population or volume is high. 4. Vaccination Progress Insights - Identify which vaccine type has the highest incomplete dosage rate (Dose 1 vs Dose 2). - Highlight segments (state/age/gender) where completion rates are lagging. 5. Notable Patterns - Call out any consistent trends (e.g., certain age groups performing better across all states, or a vaccine performing consistently well/poorly). - Mention any unusual or standout observations. Output Requirements: - Limit to 4–6 bullet points only. - Use clear, non-technical language. - Include numbers/percentages where impactful. - Prioritize insights that would matter to a decision-maker. - Avoid repeating obvious KPI values unless needed for context. Tone: Crisp, executive summary style.'
  const [filtersDropdown, setFiltersData] = useState()
  const [showInfoDialog, setShowInfoDialog] = useState(false)
  const { getRefreshDateFilter, getStateFilter, getAgeGroupFilter, getGenderFilter,
    getVaccineTypeFilter, setRefreshDateFilter, setStateFilter, setAgeGroupFilter, setGenderFilter, setVaccineTypeFilter } =
    useGeoState()
  const [getIncedenseData, setIncidenceData] = useState('')
  const [getIncedenseDataSet, setIncidenceDataSet] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const { data: filtersData, error: filtersDataError } = useGeoFetch(
    '',
    '',
    'meningitisFilters',
    '', {}, 'POST'
  )

  useEffect(() => {
    if (filtersData !== null && filtersData !== undefined) {
      setFiltersData(filtersData.response_data)
    }
  }, [filtersData])

  const ResetFilters = (event) => {
    setStateFilter('All');
    setAgeGroupFilter('All');
    setGenderFilter('All');
    setRefreshDateFilter('1991-01-01');
    setVaccineTypeFilter('All')
  }
  const AskAI = (prompt) => {
    setIsLoading(true)
    setShowInfoDialog(true)
    //researcher, doctor, medical professional, medical provider
    const BASE_URL = process.env.REACT_APP_BACKEND_BASE_URL
    const saveImageApiUrl = `${BASE_URL}/getopenaianalyserdata`
    const payload = {
      geo_id: getRefreshDateFilter,
      geo_type: 'STATE',
      geo_parent:'US',
      prompt: prompt,
      disease: 'MENINGITIS',
      data_set: 'MAP',
      user_role: '',
      age_bucket:getAgeGroupFilter,
      vaccine_type:getVaccineTypeFilter,
      gender:getGenderFilter,
      refresh_date: getRefreshDateFilter

    };
    fetch(saveImageApiUrl, {
      method: 'post',
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'text/plain',
        requester: JSON.stringify(window.localStorage.getItem('requester')),
      },
      credentials: 'include',
    })
      .then((res) => {
        setIsLoading(false)
        if (!res.ok) throw new Error('Upload failed')
        return res.json()
      })
      .then((result) => {
        setIsLoading(false)
        console.log(result)
        setIncidenceData(result)
        setIncidenceDataSet(getIncedenseDataSet => [...getIncedenseDataSet, result])
        // setSearchText('')

      })
  }


  return (
    <>
      <div className={styles.base}>
        
        {filtersDropdown && filtersDropdown.refresh_date && <div className={styles.pageDiseaseList}>
          <p>Refresh Date</p>
          <DropDownList
            id="refreshDate"
            onChange={(e) => {
              setRefreshDateFilter(e.target.value)
            }}
            className={styles.dropDowns}
            value={getRefreshDateFilter}
          >
            {filtersDropdown.refresh_date.map((type) => (
              <DropDownList.Item value={type.label} key={type.label}>
                {type.value}
              </DropDownList.Item>
            ))}
          </DropDownList>

        </div>}
        {filtersDropdown && filtersDropdown.state && <div className={styles.pageDiseaseList}>
          <p>State</p>
          <DropDownList
            id="state"
            onChange={(e) => {
              setStateFilter(e.target.value)
            }}
            className={styles.dropDowns}
            value={getStateFilter}
          >
            {filtersDropdown.state.map((type) => (
              <DropDownList.Item value={type.label} key={type.label}>
                {type.value}
              </DropDownList.Item>
            ))}
          </DropDownList>

        </div>}
        {filtersDropdown && filtersDropdown.age_group && <div className={styles.pageDiseaseList}>
          <p>Age Group</p>
          <DropDownList
            id="ageGroup"
            onChange={(e) => {
              setAgeGroupFilter(e.target.value)
            }}
            className={styles.dropDowns}
            value={getAgeGroupFilter}
          >
            {filtersDropdown.age_group.map((type) => (
              <DropDownList.Item value={type.label} key={type.label}>
                {type.value}
              </DropDownList.Item>
            ))}
          </DropDownList>


        </div>}
        {filtersDropdown && filtersDropdown.gender && <div className={styles.pageDiseaseList}>
          <p>Gender</p>
          <DropDownList
            id="gender"
            onChange={(e) => {
              setGenderFilter(e.target.value)
            }}
            className={styles.dropDowns}
            value={getGenderFilter}
          >
            {filtersDropdown.gender.map((type) => (
              <DropDownList.Item value={type.label} key={type.label}>
                {type.value}
              </DropDownList.Item>
            ))}
          </DropDownList>
        </div>}
        {filtersDropdown && filtersDropdown.vaccine_type && <div className={styles.pageDiseaseList}>
          <p>Vaccine Type</p>
          <DropDownList
            id="vaccineType"
            onChange={(e) => {
              setVaccineTypeFilter(e.target.value)
            }}
            className={styles.dropDowns}
            value={getVaccineTypeFilter}
          >
            {filtersDropdown.vaccine_type.map((type) => (
              <DropDownList.Item value={type.label} key={type.label}>
                {type.value}
              </DropDownList.Item>
            ))}
          </DropDownList>
        </div>}
        <button className={styles.buttonClass} onClick={ResetFilters}>Reset Filter</button>
        {/* <button className={styles.buttonClass} onClick={() => AskAI(promptText)}>ASK AI</button> */}
      </div>

      <Modal open={showInfoDialog} onClose={() => setShowInfoDialog(false)} center>
        <div style={{ overflowY: 'auto', maxHeight: 'calc(85vh - 60px)', overflowX: 'hidden' }}>

          <div style={{ display: 'flex' }}>
            <img src={birIcon} alt="AI" style={{ height: '20px', width: '20px', cursor: 'pointer', marginTop: '3px' }}></img>
            <p style={{ fontWeight: 'bold', fontSize: '18px', paddingLeft: '10px' }}>  IDP Data Analyser </p></div><br />

          <div style={{ marginBottom: '10px', fontSize: '14px' }}><p style={{ fontSize: '16px' }}> <p>Here the response from AI Agent</p></p>
            <br /></div>

          <div className={styles.promptList} >

            {getIncedenseData !== undefined && getIncedenseDataSet !== undefined && isLoading == false ?

              <AIContent
                content={getIncedenseData}
                contentObject={getIncedenseDataSet}
              />
              : <div><strong>Analyzing...</strong><br></br><Spinner /></div>
            }

          </div>
          <br></br>
          <p style={{fontSize:'14px',color:'#002d72',fontWeight:'700'}}>Select one of the suggestions below for more details about the selected dataset.</p>
          <div className={styles.promptList} >
            <div className={styles.promptDiv}
              onClick={() => AskAI(`Analyze the data as a healthcare provider and shared the feedback in bullet points. List all the state with its level in tabular format.`)}>
              <p>Analyze the image as a healthcare provider</p>
            </div>
            <div className={styles.promptDiv}
              onClick={() => AskAI(`Analyze the data as a medical researcher and provide the clear insights of the data. List all the state with its high levels & very high levels.`)}>
              <p>Analyze the image as a medical researcher</p>
            </div>
            <div className={styles.promptDiv}
              onClick={() => AskAI(`Think as healthcare professional share some actionable insights based on the data. Please highlights some key factors as well. List all the states with risk level and sort description as well in tabular format.`)}>
              <p>Think as healthcare professional</p>
            </div>
            <div className={styles.promptDiv}
              onClick={() => AskAI(`Analyze this data showing the United States locations, color coded by thresholds. Generate insights from the data from the perspective of three different roles Public Health Official Focus on identifying high risk areas, potential outbreak zones, and resource allocation needs. Data Scientist Highlight patterns, anomalies, and correlations in the data. Suggest further data sources or modeling approaches. Policy Maker Interpret the implications for public health policy, funding priorities, and regional preparedness strategies. Include comparisons across roles where relevant, and suggest next steps for each role based on the data insights.`)}>
              <p>Analyze this geo-spatial data</p>
            </div>
            <div className={styles.promptDiv}
              onClick={() => AskAI(`Analyze this data showing the United States map with MSA (Metropolitan Statistical Area) locations, color-coded by FLU incident rate thresholds. Generate insights from the data from the perspective of the following roles: Public Health Official: Identify high-risk areas, potential outbreak zones, and resource allocation needs. Data Scientist: Highlight patterns, anomalies, and correlations in the data. Suggest further data sources or modeling approaches. Policy Maker: Interpret the implications for public health policy, funding priorities, and regional preparedness strategies. Epidemiologist: Assess transmission dynamics, regional spread patterns, and potential epidemiological drivers. Recommend surveillance or intervention strategies. Include comparisons across roles where relevant, and suggest next steps for each role based on the data insights.`)}>
              <p>Analyze this geo-spatial data & Include comparisons across roles where relevant</p>
            </div>
          </div>

        </div>
      </Modal>
    </>
  )
}

export default Filters
